import { generatePath } from 'react-router-dom';
import { routePaths } from 'router';
import type { IInvoiceRelatedLinksProps, IRelatedLinkParams } from './types';

export const getRelatedLinkParams = (props: IInvoiceRelatedLinksProps): IRelatedLinkParams | null => {
  const { order, trip, warehouseTask } = props;

  if (order) {
    return {
      path: generatePath(routePaths.order, { orderId: String(order.id) }),
      text: order.compositeId,
    };
  }

  if (trip) {
    return {
      path: generatePath(routePaths.trip, { tripId: String(trip.id) }),
      text: trip.compositeId,
    };
  }

  if (warehouseTask) {
    return {
      path: generatePath(routePaths.whTask, { whTaskId: String(warehouseTask.id) }),
      text: warehouseTask.compositeId,
    };
  }

  return null;
};
